import { createFileRoute, Link } from '@tanstack/react-router';
import { basicHead } from '../../../utility/head';
import { blogCategories } from '../../../assets/data/blogs';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { BottomCTA } from '../../../components/BottomCTA';
import EmpowerShape from '../../../assets/shapes/empower.svg?react';
import { Button } from '@sc/shared-ui';

export const Route = createFileRoute('/_marketing/blog/')({
  component: RouteComponent,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    categories: blogCategories,
    seo: {
      title: 'Blog - Stark Crawl',
      description:
        'The Stark Crawl blog — practical guides on AI knowledge bases, knowledge management, and making your team more productive.',
      keywords:
        'AI knowledge base blog, knowledge management, Stark Crawl blog, AI guides',
    },
  }),
  head: basicHead,
});

function RouteComponent() {
  const { categories } = Route.useLoaderData();

  return (
    <div className="relative overflow-x-hidden">
      <EmpowerShape
        className="absolute right-0 top-20 translate-x-1/2 w-216 opacity-4 pointer-events-none"
        aria-hidden="true"
      />

      {/* ─── Header ──────────────────────────────────────────────────────── */}
      <section className="pt-15 lg:pt-20 pb-10 px-5">
        <div className="max-w-315 mx-auto">
          <Breadcrumbs
            center
            items={[{ label: 'Home', path: '/' }, { label: 'Blog' }]}
          />
          <h1 className="font-grotesque text-[2.625rem] leading-[1.15] lg:text-[4.375rem] lg:leading-none font-medium text-white mt-5 text-center">
            Browse by <span className="text-primary-400">topic</span>
          </h1>
        </div>
      </section>

      {/* ─── Topic Boxes ─────────────────────────────────────────────────── */}
      <section className="pb-25 px-5">
        <div
          className="max-w-240 mx-auto grid grid-cols-1 md:grid-cols-2 gap-5"
          role="region"
          aria-label="Blog topics"
        >
          {categories.map((category) => (
            <div
              key={category.slug}
              className="bg-background-tertiary backdrop-blur-[6.25rem] rounded-md flex flex-col"
            >
              <div className="flex justify-between border-grey-t-700 border-b py-2 px-3 items-center">
                <h2 className="font-open text-sm tracking-wider text-white ">
                  {category.name}
                </h2>
                <Button
                  button={{
                    text: 'View all',
                    size: 'small',
                    type: 'tertiary',
                    shrink: true,
                  }}
                  link={{
                    to: '/blog/$slug',
                    params: { slug: category.slug },
                  }}
                />
              </div>
              <ul className="flex flex-col gap-3 p-3 flex-1" role="list">
                {category.posts.map((post) => (
                  <li key={post.slug}>
                    <Link
                      to="/blog/$slug"
                      params={{ slug: post.slug }}
                      className="flex flex-col gap-1 rounded-xs transition-colors group"
                    >
                      <h3 className="font-open hover:underline text-base leading-6 font-semibold text-white">
                        {post.title}
                      </h3>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* ─── Bottom CTA ──────────────────────────────────────────────────── */}
      <BottomCTA />
    </div>
  );
}
